<template>
  <v-menu
    min-width="300"
    top
    v-model="menu"
    :close-on-click="false"
    :close-on-content-click="false"
    :nudge-top="65"
    offset-x
  >
    <template v-slot:activator="{ on }">
      <v-fab-transition>
        <v-btn
          v-show="$store.state.showChat"
          style="background-color: rgb(43, 57, 144)"
          v-model="fab"
          v-on="on"
          @click="
            fab = !fab;
            menu = false;
          "
          dark
          fixed
          bottom
          right
          fab
          :class="displayChat"
        >
          <v-icon v-if="fab">
            mdi-close
          </v-icon>
          <v-icon v-else>
            mdi-account-circle
          </v-icon>
        </v-btn>
      </v-fab-transition>
    </template>

    <chat-message
      :messages="messages"
      @sendMessage="sendMessage"
      @likeMessage="likeMessage"
      ref="scroll"
    />
  </v-menu>
</template>

<script>
/* eslint-disable */
const url = require("@/client_config/config").url;
import socket from "@/socket";
import ChatMessage from '@/components/chat/groupChat/ChatMessage'

export default {
  components: {
    ChatMessage
  },
  data: () => ({
    fab: false,
    fav: true,
    menu: false,
    messages: [],
    message: "",
  }),
  created() {
    socket.connect();

    socket.emit("addUser", localStorage.getItem("userID"));

    socket.on("receive-message", (message) => {
      const postMessage = {
        User: message.User,
        Message: message.Message,
        createdAt: Date.now(),
        me: message.User._id === localStorage.getItem("userID") ? true : false,
      };

      this.messages = [...this.messages, postMessage];
    });

    socket.on("chat-message-likes", (data) => {
      this.$store.dispatch("chatMessageLikes", data);
    });

    this.getChats();
  },

  computed: {
    displayChat() {
      return this.$route.name === "Calendar" ||
        this.$route.name === "Shifts" &&
        this.$vuetify.breakpoint.smAndDown
        ? "d-none"
        : "";
    },
  },

  methods: {
    getChats() {
      this.messages = this.$store.state.chats.messages;
    },

    sendMessage(msg) {
      const data = {
        User: localStorage.getItem("userID"),
        Message: msg,
      };

      this.$store.dispatch("sendMessage", data).then((res) => {
        const msgData = {
          User: this.$store.state.users.allUsers.find(
            (user) => user._id == res.data.User
          ),
          Message: res.data.Message,
          me: res.data.User === localStorage.getItem("userID") ? true : false,
          createdAt: res.data.createdAt,
        };
        this.messages = [...this.messages, msgData];

        socket.emit("send-message", msgData);
      }).finally(() => this.$refs.scroll.scrollToEnd());
    },

    likeMessage(chatMessageID, isChatMessageLiked) {
      const userID = localStorage.getItem("userID"),
        data = [
          {
            chatID: chatMessageID,
            userID: userID,
            isLike: [ { userID: userID, isLike: !isChatMessageLiked } ]
          }
        ];

      this.$store.dispatch("likeChatMessage", data)
        .then((response) => {
          if (response.status === 200) {
            socket.emit("like-chat-message", data);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  },
};
</script>

<style scoped>

.message-content {
  max-width: 200px;
}

.v-application .text-overline {
  font-size: 1rem !important;
}
</style>
